const $$splitComponentImporter = () => import('/src/src/routes/(compatibility)/enterprises.$enterpriseId.folders.$folderId.resources.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";

/**
 * Redirect legacy admin resources links to admin folder route
 *
 * @deprecated
 */
export const Route = createFileRoute("/(compatibility)/enterprises/$enterpriseId/folders/$folderId/resources")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});